import type { AutomaticEmissionOutcome } from '@/services/integrations';

export interface AutomaticEmissionToast {
  type: 'success' | 'warning' | 'error' | 'info';
  title: string;
  description: string;
}

const TITLES: Record<AutomaticEmissionOutcome, AutomaticEmissionToast> = {
  EMITTED: {
    type: 'success',
    title: 'Apólice emitida automaticamente',
    description: 'A emissão pela integração foi concluída.',
  },
  // A tentativa falhou, mas o sistema se recuperou sozinho: a proposta voltou a
  // aguardar emissão manual. Aviso, não erro — nada ficou quebrado.
  RETURNED_TO_MANUAL: {
    type: 'warning',
    title: 'Não foi possível emitir — voltou para a emissão manual',
    description: 'A proposta voltou a aguardar emissão manual.',
  },
  // O i4Pro já emitiu e uma etapa seguinte falhou: exige ação (Reprocessar).
  FAILED_AFTER_I4PRO: {
    type: 'error',
    title: 'Emitida no i4Pro, mas uma etapa seguinte falhou',
    description: 'Use "Reprocessar" para retomar da etapa que falhou.',
  },
};

/**
 * Traduz o desfecho da tentativa de emissão automática no aviso da tela. A
 * mensagem do BFF (que traz o motivo da falha) tem prioridade sobre o texto
 * padrão.
 */
export function describeAutomaticEmissionOutcome(
  outcome: AutomaticEmissionOutcome | undefined,
  message?: string
): AutomaticEmissionToast {
  const base = outcome ? TITLES[outcome] : undefined;

  if (!base) {
    return {
      type: 'info',
      title: 'Tentativa de emissão automática concluída',
      description: message || 'Atualize a página para ver o estado da emissão.',
    };
  }

  return { ...base, description: message || base.description };
}
